import styled from 'styled-components'

export const Container = styled.div`
    border-radius: 0px 8px 8px 0px;
    border-left: ${({ theme }) => `3px solid ${theme.colors.blue}`};
    padding: 6px;
    display: flex;
    flex-direction: column;
    width: max-content;
    height: max-content;
    margin-bottom: 1rem;
    background-color: ${({ theme }) => theme.colors.white};
`

export const SupplierInfo = styled.span`
    font-size: 14px;
    font-family: Work Sans;
    margin-left: 0.4rem;
    font-weight: bold;
`

export const Action = styled.span`
    font-size: 13px;
    font-family: Work Sans;
    margin-left: 1.2rem;
    font-weight: bold;
`

export const PossibleActionName = styled.li`
    list-style-type: disc;
    font-size: 13px;
    font-family: Work Sans;
    margin-left: 2.6rem;
    font-weight: bold;
`

export const PossibleActionDescription = styled.span`
    font-size: 13px;
    font-family: Work Sans;
    font-weight: bold;
    color: gray;
`
